module.exports = __webpack_public_path__ + "img/logo-hermanoscristianos.f842f4d0.png";